(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["partner-scroller"] && !Shopify.designMode) return;
  try {
    
  var changtuSwiper = new Swiper ('.changtu-swiper', {
  slidesPerView: "auto",
  speed: 5000, //匀速时间
  loop: true,
  autoplay: {
  delay: 0,
  },
  })

  } catch(e) { console.error(e); }
})();
})();
